export const projects = [
   { id:1,
    name:'Wedding Dress',
    img:"https://i.ibb.co/wYQnpKs/img1.png",
    link:"https://wedding-bridal-dress.web.app/",
    github:"https://github.com/ijsathi/Wedding-dresses-project12",
    description:"This is a Wedding dress'es collection project.This project has been made Responsive. React-JS, Node-JS, MongoDB, Express-JS, Bootstrap, Material-UI, Firebase for authentication, Heroku for server deploying etc are used in the project.There is an admin panel here. Admin dress add, can manage all orders. Users will be able to give reviews."},
    { id:2,
      name:'Travel Agency',
    img:"https://i.ibb.co/QmhXMW8/img2.png",
    link:"https://travel-agency-tour.web.app/",
    github:"https://github.com/ijsathi/Travel-Agency-Project11",
    description:"This is a travel agency. There are several sights here.This project has been made Responsive. React-JS, Node-JS, MongoDB, Express-JS, Bootstrap, Firebase for authentication, Heroku for server deploying etc are used in the project. Here user can add place.If you like it, you can visit the project. Thanks in advance for visiting my project."},
    { id:3,
      name:'Saveo Private Nursing',
    img:"https://i.ibb.co/cr5BcZT/img3.png",
    link:"https://saveo-private-nursing.netlify.app/",
    github:"https://github.com/ijsathi/Saveo-nursning",
    description:"This is a private nursing project. Here are some hospital related services. There are several doctors here. The first page of this project has been made responsive. React-JS, Bootstrap, Firebase for authentication etc are used in the project. Here you can add user place.If you like it, you can visit the project. Thanks in advance for visiting."},
    { id:4,
      name:'Calculator',
        img:"https://i.ibb.co/vHFNPRL/img4.png",
       link:"https://calculator-ijs.netlify.app/",
       github:"https://github.com/ijsathi/calculator",
       description:"This is a calculator. Just done with HTML, CSS, JAVASCRIPT."},
    { id:5,
      name:'Childhood Memories',
    img:"https://i.ibb.co/tMsV4BG/img5.png",
    link:"https://angry-goldwasser-bfe683.netlify.app/",
    github:"https://github.com/ijsathi/childhood-bootstrap",
    description:"This is a childhood memory related project. Made with an HTML, CSS, Bootstrap."},
    { id:6,
      name:'FootBall Live',
    img:"https://i.ibb.co/n8Q0F09/img6.png",
    link:"https://player-copa-america.netlify.app/",
    github:"https://github.com/ijsathi/football-live",
    description:"This is a play related project. Made with an HTML, CSS."},
    ]
    export default projects;